import React from 'react';
import { formatCurrency, formatDate, getAccountTypeColor } from '../../../Utility/Formatters';

const AccountCard = ({ account, index ,handleAddNewObligationPopup}) => {
  const isIncluded = account.includedInObligation;
  const cardDelay = `${index * 50}ms`;

  return (
    <div 
      className={`account-card ${isIncluded ? 'included' : 'excluded'}`}
      style={{ animationDelay: cardDelay }}
    >
      {/* Header Gradient */}
      <div className={`card-header-gradient ${getAccountTypeColor(account.accType)}`} />
      
      {/* Status Badge */}
      <div className={`status-badge ${isIncluded ? 'included' : 'excluded'}`} style={{zIndex:'0'}}>
        <i className={`fa ${isIncluded ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
        {isIncluded ? 'Included' : 'Excluded'}
      </div>

      <div className="card-content">
        {/* Account Type */}
        <div className="account-type-section">
          <i className={`fa ${account.accType === 'Credit Card' ? 'fa-credit-card' : 'fa-money'} account-icon personal-loan `}></i>
          <div className="account-type-info">
            <h3>{account.accType}</h3>
            <p>{account.securityStatus}</p>
          </div>
        </div>

        {/* Financial Overview */}
        <div className="financial-overview">
          <div className="financial-item">
            <p>Current Balance</p>
            <p>{formatCurrency(account.currentBal)}</p>
          </div>
          <div className="financial-item">
            <p>Disbursed Amount</p>
            <p>{formatCurrency(account.disbursedAmt)}</p>
          </div>
        </div>

        {/* EMI Information */}
        {account.emiAmt && (
          <div className="emi-section">
            <div className="emi-content">
              <div className="emi-info">
                <p>Monthly EMI</p>
                <p>{formatCurrency(account.emiAmt)}</p>
              </div>
              {account.roi && (
                <div className="emi-details">
                  <p>{account.roi}% ROI</p>
                  {account.tenure && (
                    <p>{account.tenure} months</p>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Dates */}
        <div className="dates-section">
          <div className="date-item">
            <i className="fa fa-calendar"></i>
            <span>Disbursed: {formatDate(account.disburseDate)}</span>
          </div>
        </div>

        {/* Obligation Status */}
        <div className="obligation-section">
          {isIncluded ? (
            <div>
              <p className="obligation-title included">Inclusion Reason</p>
              <p className={`obligation-reason included`}>
                {account.inclusionReason}
              </p>
              {account.condition && (
                <p className="obligation-condition">{account.condition}</p>
              )}
            </div>
          ) : (
            <div>
              <p className="obligation-title excluded">Exclusion Reason</p>
              <p className={`obligation-reason excluded`}>
                {account.exclusionReason}
              </p>
              <div className="add-button-container">
                <button 
                  className="add-to-obligation-btn"
                  onClick={()=>{handleAddNewObligationPopup(true,account)}}
                 
                >
                  <div className="btn-content" style={{zIndex:'0'}}>
                    <i className="fa fa-plus-circle btn-icon"></i>
                    <span className="btn-text">Add</span>
                  </div>
                  <div className="btn-shine"></div>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Hover Effect Overlay */}
      <div className="hover-overlay" />
    </div>
  );
};

export default AccountCard;